import { ManufacturingLifecycleStatus } from '../../constants/manufacturing-lifecycle-status.js';
// WHY: DRAFT is absent both sides — a work order is created only at release, so it is born ISSUED — see design spec §3.
const ALLOWED = {
    [ManufacturingLifecycleStatus.ISSUED]: [
        ManufacturingLifecycleStatus.PICK,
        ManufacturingLifecycleStatus.CANCELLED,
    ],
    [ManufacturingLifecycleStatus.PICK]: [
        ManufacturingLifecycleStatus.PICK,
        ManufacturingLifecycleStatus.IN_PROGRESS,
        ManufacturingLifecycleStatus.ISSUED,
        ManufacturingLifecycleStatus.CANCELLED,
    ],
    [ManufacturingLifecycleStatus.IN_PROGRESS]: [
        ManufacturingLifecycleStatus.IN_TESTING,
        ManufacturingLifecycleStatus.COMPLETED,
        ManufacturingLifecycleStatus.ISSUED,
        ManufacturingLifecycleStatus.CANCELLED,
    ],
    [ManufacturingLifecycleStatus.IN_TESTING]: [
        ManufacturingLifecycleStatus.COMPLETED,
        ManufacturingLifecycleStatus.IN_PROGRESS,
        ManufacturingLifecycleStatus.CANCELLED,
    ],
};
export function canTransitionWorkOrder(from, to) {
    return ALLOWED[from]?.includes(to) ?? false;
}
//# sourceMappingURL=can-transition-work-order.js.map